import React from 'react';
import { Tooltip as MaterialTooltip } from '@material-ui/core';
import Icons from 'components/Icons';

interface Props {
  text: any;
  isRedBg?: boolean;
  size?: number;
}

const Tooltip = ({ text, isRedBg = false, size = 24 }: Props) => {
  return (
    <MaterialTooltip title={text} arrow>
      <Icons.HelpIcon
        style={{
          color: isRedBg ? 'white' : 'currentColor',
          width: `${size}px`,
          height: `${size}px`
        }}
      />
    </MaterialTooltip>
  );
};

export default Tooltip;
